import React from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { ActionButton } from "../../../../../../_metronic/_partials/controls/ActionButton";
import { deleteOrganization } from "../../../_redux/organization/organizationAction";

export default function OrganizationDeleteModal({
  show,
  onCancel,
  organization = {}
}) {
  const { actionsLoading } = useSelector(
    state => ({
      actionsLoading: state.superAdminOrganization.actionsLoading
    }),
    shallowEqual
  );
  const dispatch = useDispatch();

  const history = useHistory();

  function onDelete() {
    dispatch(deleteOrganization(organization.uuid))
      .then(res => {
        toast.success(res.message);
        history.push("/admin/organization");
      })
      .catch(err => {
        console.log(`err`, err);
        onCancel();
      });
  }

  return (
    <>
      <Modal
        size="md"
        show={show}
        centered
        onHide={onCancel}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Hapus lembaga {organization.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: "64px", color: `#F64E60` }}
            ></i>
          </div>
          <div className="mt-8 text-center">
            <strong>
              Apakah anda yakin ingin menghapus lembaga {organization.name}
            </strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center">
            <ActionButton
              type="button"
              loading={actionsLoading}
              style={{ width: "75px", height: "35.59px" }}
              className="btn btn-secondary btn-elevate mx-1"
              onClick={onCancel}
              text="Batal"
            />

            <ActionButton
              type="button"
              loading={actionsLoading}
              style={{ width: "75px", height: "35.59px" }}
              className="btn btn-primary btn-elevate mx-1"
              onClick={onDelete}
              text="Hapus"
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
